export default {"src":"/_next/static/media/report-new.0a73f698.svg","height":32,"width":32};